import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./manageZones.css"; // Reusing the existing styles

const ManageZones = () => {
  const [zones, setZones] = useState([]);
  const [zoneName, setZoneName] = useState("");
  const [editingZone, setEditingZone] = useState(null);
  const [deletingZoneId, setDeletingZoneId] = useState(null); // Track which zone is being deleted

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchZones();
  }, []);

  // Fetch all zones
  const fetchZones = async () => {
    try {
      const response = await axios.get(`${API_URL}/zones/all-zones`);
      setZones(response.data);
    } catch (error) {
      console.error("Error fetching zones:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch zones",
        icon: "error",
      });
    }
  };

  // Add or Update a Zone
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!zoneName.trim()) {
      Swal.fire({
        title: "Error",
        text: "Zone name cannot be empty",
        icon: "error",
      });
      return;
    }

    try {
      if (editingZone) {
        await axios.put(`${API_URL}/zones/edit-zone/${editingZone._id}`, { name: zoneName });
        Swal.fire({
          title: "Success",
          text: "Zone updated successfully",
          icon: "success",
        });
      } else {
        await axios.post(`${API_URL}/zones/add-zone`, { name: zoneName });
        Swal.fire({
          title: "Success",
          text: "Zone added successfully",
          icon: "success",
        });
      }

      setZoneName("");
      setEditingZone(null);
      fetchZones();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Error saving zone",
        icon: "error",
      });
      console.error(error);
    }
  };

  // Start editing a zone
  const startEditing = (zone) => {
    setEditingZone(zone);
    setZoneName(zone.name);
  };

  // Cancel editing
  const cancelEdit = () => {
    setEditingZone(null);
    setZoneName("");
  };

  // Delete a single zone
  const deleteZone = async (zoneId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setDeletingZoneId(zoneId); // Mark this zone as being deleted

        try {
          await axios.delete(`${API_URL}/zones/delete-zone/${zoneId}`);

          Swal.fire({
            title: "Deleted!",
            text: "The zone has been deleted.",
            icon: "success",
          });

          fetchZones(); // Refresh the list after deletion
        } catch (error) {
          console.error("Deletion error:", error);
          Swal.fire({
            title: "Error",
            text: "Failed to delete the zone.",
            icon: "error",
          });
        }

        setDeletingZoneId(null); // Reset deleting state
      }
    });
  };

  return (
    <div className="admin-managesubscription-container">
      <div className="admin-managesubscription-content">
        <h2>{editingZone ? "Edit Zone" : "Manage Zones"}</h2>

        <form onSubmit={handleSubmit} className="admin-managesubscription-form">
          <div className="admin-managesubscription-form-group">
            <input
              type="text"
              placeholder="Zone Name"
              value={zoneName}
              onChange={(e) => setZoneName(e.target.value)}
            />
          </div>

          <div className="admin-managesubscription-buttons">
            {editingZone ? (
              <>
                <button type="button" onClick={cancelEdit} className="admin-managesubscription-btn-secondary">
                  Cancel
                </button>
                <button type="submit" className="admin-managesubscription-btn-primary">
                  Update Zone
                </button>
              </>
            ) : (
              <button type="submit" className="admin-managesubscription-btn-primary">
                Add Zone
              </button>
            )}
          </div>
        </form>

        <h3 className="admin-managesubscription-existing-exams">Existing Zones</h3>
        <div className="admin-managesubscription-table-wrapper">
          <table className="admin-managesubscription-table">
            <thead>
              <tr>
                <th>Zone Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {zones.map((zone) => (
                <tr key={zone._id}>
                  <td>{zone.name}</td>
                  <td>
                    <button onClick={() => startEditing(zone)} className="admin-managesubscription-btn-warning">
                      Edit
                    </button>
                    <button
                      onClick={() => deleteZone(zone._id)}
                      className="admin-managesubscription-btn-danger"
                      disabled={deletingZoneId === zone._id}
                    >
                      {deletingZoneId === zone._id ? "Deleting..." : "Delete"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageZones;
